/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMlModelSingle = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M9.5 2a3.5 3.5 0 0 1 2.243 6.185l2.007 6.824a3.5 3.5 0 0 1 .513.074l.128-.36 1.885.666-.246.694a3.5 3.5 0 1 1-4.236-.64L9.892 8.978a3.527 3.527 0 0 1-.917-.017L7.458 12.6A3.5 3.5 0 1 1 5.5 12h.041l1.623-3.894A3.5 3.5 0 0 1 9.5 2zm4 15a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm-8-3a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm4-10a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z" />
        <path d="m16.333 12.223.943.332-.667 1.89-1.885-.666.667-1.889zm1.943-2.501-.667 1.889-.942-.333-.943-.332.667-1.89zm-.836-3.16a1.495 1.495 0 0 0 1.447.387l.52 1.932a3.483 3.483 0 0 1-1.813 0 3.49 3.49 0 0 1-1.57-.906zm4.44-1.969a3.49 3.49 0 0 1 0 1.813 3.49 3.49 0 0 1-.905 1.57L19.56 6.56a1.491 1.491 0 0 0 .388-1.447zm-4.441-.153a1.49 1.49 0 0 0-.388.672c-.071.265-.066.53 0 .775l-1.932.52a3.49 3.49 0 0 1 0-1.813 3.49 3.49 0 0 1 .906-1.57zm.154-2.322a3.492 3.492 0 0 1 1.813.001 3.489 3.489 0 0 1 1.57.906L19.56 4.439a1.488 1.488 0 0 0-.671-.388 1.49 1.49 0 0 0-.776 0z" />
      </g>
    </g>
  </Icon>
);
export { SvgMlModelSingle as MlModelSingle };
